import { Select } from '../../Inputs';
import { useDataProvider } from '../DataProviderContext';
import type { RowData, TableInstance } from '../tanstackTypes';
import { useTableTexts } from '../useTableTexts';

// getCanGroup only exists once the grouping feature is registered on the table
export const getGroupableColumns = <TData extends RowData>(
  table: TableInstance<TData>
) =>
  table
    .getAllLeafColumns()
    .filter(
      (column) =>
        typeof column.getCanGroup === 'function' && column.getCanGroup()
    );

export const GroupByAction = () => {
  const { table } = useDataProvider();
  const texts = useTableTexts().groupBy;

  if (!table?.options.enableGrouping) {
    return null;
  }

  const state = table.state;
  const columns = getGroupableColumns(table);

  return (
    <Select
      value={state?.grouping.at(0) || ''}
      options={columns.map((column) => ({
        value: column.id,
        label: column.columnDef.meta?.name ?? 'No name',
      }))}
      name="groupBy"
      onChange={(e) => {
        const value = e.target.value;
        table.setGrouping(value === '' ? [] : [String(value)]);
      }}
      margin="none"
      sx={{
        width: 'unset',
        minWidth: '150px',
      }}
      placeholder={texts.selector}
      showEmptyOption
      rounded
    />
  );
};
